// Shared by Tab.vue and Panel.vue. They must never disagree: a tab whose panel
// does not render is a dead button, and a panel whose tab is missing is
// unreachable. So the filter lives in exactly one place.
//
// Note this is a .ts file - the registry only scans .vue, so it is a plain module
// and not mistaken for an extension.
export const aiSelector = {
	spaceIds: [ 'bali6j22f8ll', 'bwgnke9mmkdm', 'def6345e' ],
}
